/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Spin,
} from 'antd';
import {
  deleteOtro,
  getOtro,
  getOtros,
  patchOtro,
  postOtro,
} from 'api/catalogos/Otros';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { DATE_FRONTEND_FORMAT } from 'utils/normalizers';

export const otrosPermission = {
  permissionModel: 'avisopresentardeclaracionanualisrdelempleado',
  catalogsModels: [],
  tabsModels: [],
  hasAllViewPermissions: true,
};
const OtrosHonorariosAsimilados = ({ permission, empleado_id }) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [periodo, setPeriodo] = useState([]);
  const [disableFields, setDisableFields] = useState(false);
  const [, setSelectedData] = useState({});
  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    if (!empleado_id) return;
    setLoading(true);
    const _data = await getOtros({ empleado: empleado_id });
    setData(formatReceived(_data.results || _data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      if (!empleado_id) return;
      setLoading(true);
      await checkToken();
      const [
        _data,
        _periodo,
      ] = await Promise.all([
        getOtros({ empleado: empleado_id }),
        getPeriodosFiscales(),
      ]);
      if (mounted) {
        setData(formatReceived(_data.results || _data));
        setLoading(false);
        setPeriodo(_periodo);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  // eslint-disable-next-line
}, [ empleado_id]);

  const onCancel = () => {
    setVisible(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    if (!([1].includes(key))) {
      const match = responseData || data.find((item) => item.id === key);
      const _Otro = await getOtro(match.id);
      setTimeout(() => {
        if (_Otro) {
          form.resetFields();
          setTimeout(() => {
            form.setFieldsValue(formatReceived(_Otro));
            setVisible(true);
          });
        }
      });
    }
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      values.empleado = empleado_id;
      values.fecha_de_aviso = values.fecha_de_aviso ? values.fecha_de_aviso.format('YYYY-MM-DD') : null;
      const saved = await (key ? patchOtro(key, values) : postOtro(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteOtro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const handleKeyPress = (e) => {
    if (/\d/.test(e.key)) {
      e.preventDefault();
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
    }
  };

  const columns = [
    {
      titleText: 'Periodo',
      dataIndex: 'periodo',
      key: 'periodo',
      width: 150,
      render: (val) => (val && periodo ? periodo.find((item) => item.id === val)?.periodo : 'N/A'),
    },
    {
      titleText: 'Fecha De Aviso',
      dataIndex: 'fecha_de_aviso',
      key: 'fecha_de_aviso',
      render: (val) => (val ? val?.format(DATE_FRONTEND_FORMAT) : 'N/A'),

      width: 150,
    },

  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Otros`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
            )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="periodo"
                label="Ejercicio"
                onKeyPress={handleKeyPress}
                hasFeedback
              >
                <Select
                  dataSource={periodo}
                  allowClear
                  disabled={disableFields}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="fecha_de_aviso"
                label="Fecha De Aviso"
                onKeyPress={handleKeyPress}
                rules={rules.required}
                hasFeedback
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccione una fecha"
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="el registro"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default OtrosHonorariosAsimilados;
